import React, { useEffect, useState } from "react";
import backicon from "./../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import "./PurchaseOrderDetails.scss";
import CustomTable from "../../../../customComponents/CustomTable";
import eyeIcon from "./../../../../../Assets/icons/eye 1.svg";
import editIcon from "./../../../../../Assets/icons/Un-Checkbox.svg";
import PurchaseOrder from "./PurchaseOrder";
import { Stack } from "react-bootstrap";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import Loader from "../../../../customComponents/CustomLoader";

const PurchaseOrderDetails = () => {
  const location = useLocation();
  const { PurchaseOrderdata } = location.state || {};
  const authToken = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [PurchaseOrderDetails, setPurchaseOrderDetails] = useState([]);
  const [PurchaseOrderList, setPurchaseOrderList] = useState([]);
  const [StockTypes,setStockTypes] = useState([])
  const [BUSINESSPARTNERID,SETBUSINESSPARTNERID] = useState()
  const [POTYPE,setPOTYPE] = useState("")
  const po_id = location?.state?.data?.po_id || location?.state?.POID;
  const navigate = useNavigate();
  console.log("poid>>", po_id);
  console.log("locationpo",location);
  

  
  const fetchPurchaseOrderDetails = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(`/purchaseorder/edit/${po_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const fetchedData = response.data.data;
      SETBUSINESSPARTNERID(fetchedData?.business_partner_id)
      console.log(fetchedData, "fetchedData");
      const transformedData = {
        onboard_process_type: fetchedData.onboard_process_type,
        bp_type: fetchedData.bp_type,
        bp_name: fetchedData.bp_name,
        contact_no: fetchedData.contact_no,
        email_id: fetchedData.email_id,
        pincode: fetchedData.pincode,
        city_id: fetchedData.city_id,
        country_id: fetchedData.country_id,
        state_id: fetchedData.state_id,
        bp_address: fetchedData.bp_address,
        gst_no: fetchedData.gst_no,
        remark: fetchedData.remark,
        status: fetchedData.status,
      };

      console.log(fetchedData, "fetchConfigData");
      setPurchaseOrderDetails(fetchedData);
      const stockTypes = response?.data?.data?.stock_types
      setStockTypes(stockTypes)
      setPOTYPE(PurchaseOrderDetails?.po_type)
      console.log("PurchaseOrderDetails>>>", PurchaseOrderDetails);
    } catch (error) {
      console.log(error, "error");
    }
    finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchPurchaseOrderDetails();
    //fetchPurchaseOrderList();
  }, []);
  // const fetchPurchaseOrderList = async (page=0,pageSize=10) => {
  //   try {
  //     const response = await axiosInstance.post(
  //       `/podetails/list`,{   po_id:po_id,
  //         orderBy:"po_details_id asc",
  //         page,
  //         pageSize

  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );

  //     const fetchedData = response?.data?.data?.data;

  //     setPurchaseOrderList(fetchedData);
  //     console.log("PurchaseOrderList", fetchedData);
  //   } catch (error) {
  //     console.log(error, "error");
  //   }
  // };
console.log("PurchaseOrderDetails",PurchaseOrderDetails);

return (
  <div>
    {loading ? (
      <Loader />
    ) : (
      <div>
        <div className="podetailscontainer">
          <div
            className="backbutton mt-2 mb-4"
            onClick={() => {
              navigate(ROUTES_NAVIGATION.PURCHASEORDER);
            }}
          >
            <img src={backicon} alt="back" />
            <span className="backbtntitleDetails">Purchase Order Details</span>
          </div>
          <hr />
          <div className="details-section">
            <h5 className="mt-2 mb-2 headerdetails">Order Details</h5>
            <div className="detail-grid">
              <div className="details-item">
                <span className="details-label">Business Partner</span>
                <span className="details-value">
                  {PurchaseOrderDetails.bp_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">PO No.</span>
                <span className="details-value">
                  {PurchaseOrderDetails.po_number || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">PO Date</span>
                <span className="details-value">
                  {PurchaseOrderDetails.po_date || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Purchase Order Type</span>
                <span className="details-value">
                  {PurchaseOrderDetails.potype || "-"}
                </span>
              </div>
              {PurchaseOrderDetails?.potype === "Vendor Specific" && (
                <div className="details-item">
                  <span className="details-label">Vendor Name</span>
                  <span className="details-value">
                    {PurchaseOrderDetails.companyname || "-"}
                  </span>
                </div>
              )}
              <div className="details-item">
                <span className="details-label">Reference No.</span>
                <span className="details-value">
                  {PurchaseOrderDetails.reference_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Department</span>
                <span className="details-value">
                  {PurchaseOrderDetails.department_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Payment Term</span>
                <span className="details-value">
                  {PurchaseOrderDetails.payment_term_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Payment Mode</span>
                <span className="details-value">
                  {PurchaseOrderDetails.payment_mode || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Payment Date</span>
                <span className="details-value">
                  {PurchaseOrderDetails.payment_date || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">PO Expected Date</span>
                <span className="details-value">
                  {PurchaseOrderDetails.po_expected_date || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Total Amount</span>
                <span className="details-value">
                  {PurchaseOrderDetails.total || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Showroom Center</span>
                <span className="details-value">
                  {PurchaseOrderDetails.showroom_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Remark</span>
                <span className="details-value">
                  {PurchaseOrderDetails.remark || "-"}
                </span>
              </div>
            </div>
          </div>
          <hr />
          <PurchaseOrder
            fetchPurchaseOrderDetails={fetchPurchaseOrderDetails}
            potype={PurchaseOrderDetails?.potype}
            po_id={PurchaseOrderDetails?.po_id}
            stockTypesData={StockTypes}
            vendorId={PurchaseOrderDetails?.vendor_onboard_id}
            bpid={BUSINESSPARTNERID}
            is_approved={PurchaseOrderDetails.is_approved}
          />
        </div>
      </div>
    )}
  </div>
);
};
export default PurchaseOrderDetails